import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {HotelsTable} from './table/HotelsTable'
import {HotelEditModal} from './hotel-edit-modal/HotelEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {HotelsListHeader} from './header/HotelsListHeader'

const HotelsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <HotelsListHeader />
        <HotelsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <HotelEditModal />}
    </>
  )
}

const HotelsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <HotelsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {HotelsListWrapper}
